import { render, staticRenderFns } from "./addActivity.vue?vue&type=template&id=006b3aa4&"
import script from "./addActivity.vue?vue&type=script&lang=js&"
export * from "./addActivity.vue?vue&type=script&lang=js&"
import style0 from "./addActivity.vue?vue&type=style&index=0&id=006b3aa4&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports